(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["commerce-updates"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.ChateauCommerce) return;
    let mutations = Promise.resolve();
    let movementRevision = 0;
    let viewLocks = 0;
    let previousAnchors;
    const holdAnchoring = () => {
      if (viewLocks === 0) {
        previousAnchors = [document.documentElement.style.overflowAnchor, document.body.style.overflowAnchor];
        document.documentElement.style.overflowAnchor = 'none';
        document.body.style.overflowAnchor = 'none';
      }
      viewLocks += 1;
      let released = false;
      const release = () => {
        if (released) return;
        released = true;
        viewLocks -= 1;
        if (viewLocks === 0) {
          document.documentElement.style.overflowAnchor = previousAnchors[0];
          document.body.style.overflowAnchor = previousAnchors[1];
        }
      };
      setTimeout(release, 300);
      return release;
    };
    const movementKeys = new Set(['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' ']);
    window.addEventListener('wheel', () => { movementRevision += 1; }, { passive: true });
    window.addEventListener('touchmove', () => { movementRevision += 1; }, { passive: true });
    window.addEventListener('keydown', (event) => {
      if (movementKeys.has(event.key)) movementRevision += 1;
    });
    const rootURL = () => {
      const value = document.querySelector('[data-commerce-root]')?.dataset.commerceRoot || window.Shopify?.routes?.root || '/';
      return `${value.replace(/\/$/, '')}/`;
    };
    const request = async (destination, { method = 'GET', body, signal } = {}) => {
      const url = new URL(destination, location.origin);
      if (url.origin !== location.origin) throw new Error('Invalid commerce destination');
      const controller = new AbortController();
      const abort = () => controller.abort();
      if (signal?.aborted) controller.abort();
      signal?.addEventListener('abort', abort, { once: true });
      const timeout = setTimeout(abort, 15000);
      const headers = { Accept: 'application/json' };
      if (body !== undefined && !(body instanceof FormData) && !(body instanceof URLSearchParams) && typeof body !== 'string') {
        headers['Content-Type'] = 'application/json';
        body = JSON.stringify(body);
      }
      let response;
      let data;
      try {
        response = await fetch(url, { method, body, headers, signal: controller.signal, credentials: 'same-origin', cache: 'no-store' });
        data = await response.json();
      } catch (cause) {
        if (signal?.aborted) throw cause;
        const error = new Error('Commerce response could not be confirmed', { cause });
        error.status = response?.status || 0;
        error.uncertain = method.toUpperCase() !== 'GET';
        throw error;
      } finally {
        clearTimeout(timeout);
        signal?.removeEventListener('abort', abort);
      }
      if (!response.ok) {
        const message = typeof data?.description === 'string' ? data.description : typeof data?.message === 'string' ? data.message : 'Commerce request failed';
        const error = new Error(message);
        error.status = response.status;
        error.data = data;
        error.uncertain = response.status >= 500 && method.toUpperCase() !== 'GET';
        throw error;
      }
      return data;
    };
    const captureView = (scope = document) => {
      const active = document.activeElement;
      const inside = Boolean(active && scope.contains(active));
      const view = { x: window.scrollX, y: window.scrollY, movementRevision, active, inside, releaseAnchoring: holdAnchoring() };
      if (inside) {
        view.id = active.id;
        view.name = active.getAttribute('name');
        try {
          view.selectionStart = active.selectionStart;
          view.selectionEnd = active.selectionEnd;
        } catch {}
      }
      return view;
    };
    const restoreView = (view, scope = document, { focusSelector } = {}) => {
      if (!view) return;
      if (movementRevision !== view.movementRevision) {
        view.releaseAnchoring?.();
        return;
      }
      const current = document.activeElement;
      const canRestoreFocus = view.inside && (current === document.body || current === view.active || scope.contains(current));
      if (canRestoreFocus) {
        let target;
        if (focusSelector) target = scope.querySelector(focusSelector);
        if (!target && view.id) target = scope.querySelector(`#${CSS.escape(view.id)}`);
        if (!target && view.name) target = scope.querySelector(`[name="${CSS.escape(view.name)}"]`);
        if (target && !target.disabled) {
          target.focus({ preventScroll: true });
          if (typeof target.setSelectionRange === 'function' && view.selectionStart !== null && view.selectionStart !== undefined) {
            try { target.setSelectionRange(view.selectionStart, view.selectionEnd); } catch {}
          }
        }
      }
      window.scrollTo({ left: view.x, top: view.y, behavior: 'instant' });
      requestAnimationFrame(() => {
        if (movementRevision === view.movementRevision) window.scrollTo({ left: view.x, top: view.y, behavior: 'instant' });
        requestAnimationFrame(() => view.releaseAnchoring?.());
      });
    };
    window.ChateauCommerce = {
      request,
      captureView,
      restoreView,
      cartEndpoint(action = '') { return `${rootURL()}cart${action ? `/${action}` : ''}.js`; },
      enqueue(task) {
        const result = mutations.then(task);
        mutations = result.catch(() => {});
        return result;
      },
      fetchSections(contextURL, ids, { signal } = {}) {
        const url = new URL(contextURL, location.origin);
        url.hash = '';
        url.searchParams.delete('section_id');
        url.searchParams.set('sections', [...new Set(ids)].slice(0, 5).join(','));
        return request(url, { signal });
      },
      publishCart(cart) {
        if (Number.isInteger(cart?.item_count) && cart.item_count >= 0) {
          document.querySelectorAll('[data-cart-count]').forEach((counter) => { counter.textContent = String(cart.item_count); });
          document.querySelectorAll('[data-cart-link]').forEach((link) => {
            link.setAttribute('aria-label', `${link.dataset.cartLabel} (${cart.item_count})`);
          });
        }
        document.dispatchEvent(new CustomEvent('chateau:cart:updated', { detail: { cart } }));
      },
    };
    document.dispatchEvent(new Event('chateau:commerce:ready'));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["editorial-motion"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.documentElement;
    const preference = matchMedia('(prefers-reduced-motion: reduce)');
    let finishTimer;
    let cancelled = false;
    const finish = () => {
      clearTimeout(finishTimer);
      cancelled = true;
      root.classList.remove('intro-pending');
    };
    let home = document.querySelector('[data-editorial-home]');
    const frameHome = () => {
      if (!home || home.dataset.referencePhoto !== 'true') return;
      const image = home.querySelector('.editorial-opening__photo img');
      const title = home.querySelector('h1');
      if (!image || !title) return;
      image.style.removeProperty('object-position');
      // Layout coordinates are unaffected by the photograph's CSS zoom.
      const imageStyle = getComputedStyle(image);
      const photoBounds = image.parentElement.getBoundingClientRect();
      const homeStyle = getComputedStyle(home);
      const bounds = {
        left: photoBounds.left + parseFloat(imageStyle.left),
        top: photoBounds.top + parseFloat(imageStyle.top),
        width: parseFloat(imageStyle.width),
        height: parseFloat(imageStyle.height),
      };
      const width = image.naturalWidth || Number(image.getAttribute('width'));
      const height = image.naturalHeight || Number(image.getAttribute('height'));
      if (!width || !height || !bounds.width || !bounds.height) return;
      const scale = Math.max(bounds.width / width, bounds.height / height);
      const photographWidth = width * scale;
      const photographHeight = height * scale;
      const positions = getComputedStyle(image).objectPosition.split(' ').map(parseFloat);
      if (!positions.every(Number.isFinite)) return;
      const coordinate = (name) => Number(homeStyle.getPropertyValue(name));
      // The reference photo's first pine: foliage must stay below the final title.
      const clearance = Math.max(32, parseFloat(getComputedStyle(title).fontSize) * 0.65);
      const foliageLimit = title.getBoundingClientRect().bottom + clearance;
      const overflow = photographHeight - bounds.height;
      const framingLift = Math.max(24, Math.min(72, home.getBoundingClientRect().height * 0.06));
      if (overflow > 1) {
        positions[1] = Math.min(100, positions[1] + framingLift / overflow * 100);
        image.style.objectPosition = `${positions[0]}% ${positions[1]}%`;
      }
      const foliageY = bounds.top - overflow * positions[1] / 100 + photographHeight * coordinate('--pin-top');
      if (overflow > 1 && foliageY < foliageLimit) {
        positions[1] = Math.max(0, Math.min(100, (bounds.top + photographHeight * coordinate('--pin-top') - foliageLimit) / overflow * 100));
        image.style.objectPosition = `${positions[0]}% ${positions[1]}%`;
      }
      // Keep the original photograph framing, with the zoom pivot at the crown.
      const crownBeforeZoom = bounds.top - overflow * positions[1] / 100 + photographHeight * coordinate('--pin-crown');
      home.style.setProperty('--home-photo-crown-y', `${crownBeforeZoom - bounds.top}px`);

      // Fit the supplied logo to the actually painted photo AFTER object-fit and zoom.
      // Source landmarks: first pine crown y=.552, foot y=.680, trunk axis x=.211.
      // Logo viewBox: 650x540; tree crown y=43, ground y=429, trunk axis x=325.
      // This uniform scale preserves the logo; its branches are not warped to the photo.
      const rendered = image.getBoundingClientRect();
      const paintedScale = Math.max(rendered.width / width, rendered.height / height);
      const paintedWidth = width * paintedScale;
      const paintedHeight = height * paintedScale;
      let paintedLeft = rendered.left + (rendered.width - paintedWidth) * positions[0] / 100;
      const paintedTop = rendered.top + (rendered.height - paintedHeight) * positions[1] / 100;
      const pineCrownY = paintedTop + paintedHeight * coordinate('--pin-crown');
      const pineFootY = paintedTop + paintedHeight * coordinate('--pin-base');
      let pineAxisX = paintedLeft + paintedWidth * coordinate('--pin-x');
      const homeBounds = home.getBoundingClientRect();
      const frameGutter = Math.max(2, photoBounds.width * 0.01);
      const logoWidth = Math.min((pineFootY - pineCrownY) * 650 / (429 - 43), photoBounds.width - 2 * frameGutter, homeBounds.width * 0.85, homeBounds.height * 650 / 540 * 0.86);
      // Reveal the entire left pine on narrow frames instead of letting its logo spill
      // into the black panel. Only object-position changes; the panel split stays fixed.
      const safeAxis = Math.max(photoBounds.left + frameGutter + logoWidth / 2, Math.min(photoBounds.right - frameGutter - logoWidth / 2, pineAxisX));
      const horizontalCrop = paintedWidth - rendered.width;
      if (horizontalCrop > 1 && Math.abs(safeAxis - pineAxisX) > 0.1) {
        positions[0] = Math.max(0, Math.min(100, positions[0] - (safeAxis - pineAxisX) / horizontalCrop * 100));
        image.style.objectPosition = `${positions[0]}% ${positions[1]}%`;
        paintedLeft = rendered.left + (rendered.width - paintedWidth) * positions[0] / 100;
        pineAxisX = paintedLeft + paintedWidth * coordinate('--pin-x');
      }
      const logoHeight = logoWidth * 540 / 650;
      home.style.setProperty('--intro-logo-width', `${logoWidth}px`);
      home.style.setProperty('--logo-shift-x', `${pineAxisX - homeBounds.left - homeBounds.width / 2}px`);
      home.style.setProperty('--logo-shift-y', `${pineCrownY - homeBounds.top - homeBounds.height / 2 + logoHeight * (0.5 - 43 / 540)}px`);

    };
    // Framing also applies when the introduction is disabled or motion is reduced.
    frameHome();
    home?.querySelector('.editorial-opening__photo img')?.addEventListener('load', frameHome);
    document.fonts?.ready.then(frameHome);
    let resizeFrame;
    window.addEventListener('resize', () => {
      finish();
      cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(frameHome);
    });
    if (!home || home.dataset.introEnabled === 'false' || preference.matches || window.Shopify?.designMode || performance.getEntriesByType('navigation')[0]?.type === 'back_forward') {
      finish();
    } else {
      requestAnimationFrame(() => {
        if (cancelled) return;
        frameHome();
        const started = document.timeline.currentTime;
        for (const animation of document.getAnimations()) {
          const target = animation.effect?.target;
          if (target?.closest('[data-editorial-home], .site-header')) animation.startTime = started;
        }
        root.dataset.introStarted = String(started);
        finishTimer = setTimeout(finish, 6950);
      });
    }
    ['keydown', 'pointerdown', 'wheel', 'touchstart', 'focusin'].forEach((type) => document.addEventListener(type, finish, { once: true, passive: true }));
    document.addEventListener('scroll', finish, { once: true, passive: true });
    window.addEventListener('pageshow', (event) => { if (event.persisted) finish(); });
    document.addEventListener('shopify:section:load', () => {
      finish();
      home = document.querySelector('[data-editorial-home]');
      frameHome();
    });
    preference.addEventListener('change', finish);
    const signaturePairs = new Map();
    const signatureCanvas = document.createElement('canvas').getContext('2d');
    let signatureFrame;
    const alignSignatures = () => {
      if (!matchMedia('(min-width: 750px)').matches) return;
      for (const [signature, content] of signaturePairs) {
        if (!signature.isConnected || !content.isConnected) continue;
        const logo = signature.querySelector('.brand-logo__image--dominium');
        if (!logo) continue;
        const walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT, {
          acceptNode: (node) => node.textContent.trim() && !node.parentElement.closest('script, style, [hidden]') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT,
        });
        let last;
        while (walker.nextNode()) {
          const node = walker.currentNode;
          const range = document.createRange();
          const end = node.textContent.trimEnd().length;
          range.setStart(node, end - 1);
          range.setEnd(node, end);
          if (range.getBoundingClientRect().height) last = { node, range };
        }
        if (!last) continue;
        const style = getComputedStyle(last.node.parentElement);
        signatureCanvas.font = `${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;
        const descent = signatureCanvas.measureText('Mg').fontBoundingBoxDescent || parseFloat(style.fontSize) * 0.22;
        let motionOffset = 0;
        for (let element = last.node.parentElement; element && element !== content.parentElement; element = element.parentElement) {
          const transform = getComputedStyle(element).transform;
          if (transform !== 'none') motionOffset += new DOMMatrixReadOnly(transform).m42;
        }
        const baseline = last.range.getBoundingClientRect().bottom - descent - motionOffset;
        const holder = signature.classList.contains('editorial-signature') ? signature : signature.parentElement;
        const underline = baseline + parseFloat(style.fontSize) * 0.22 + 2;
        const top = underline - holder.getBoundingClientRect().top - logo.getBoundingClientRect().width * 429 / 650;
        signature.style.setProperty('--signature-top', `${top}px`);
      }
    };
    const scheduleSignatures = () => {
      cancelAnimationFrame(signatureFrame);
      signatureFrame = requestAnimationFrame(alignSignatures);
    };
    const signatureObserver = new ResizeObserver(scheduleSignatures);
    const findSignatures = () => {
      for (const [signature] of signaturePairs) {
        if (!signature.isConnected) signaturePairs.delete(signature);
      }
      document.querySelectorAll('.editorial-signature, .contact-page__signature').forEach((signature) => {
        const content = signature.closest('.renaissance-copy')?.querySelector('.renaissance-copy__inner') || signature.closest('.contact-page__layout')?.querySelector('.contact-page__form-panel');
        if (!content || signaturePairs.has(signature)) return;
        signaturePairs.set(signature, content);
        signatureObserver.observe(content);
        signature.querySelector('img')?.addEventListener('load', scheduleSignatures);
      });
      scheduleSignatures();
    };
    findSignatures();
    document.fonts?.ready.then(scheduleSignatures);
    window.addEventListener('resize', scheduleSignatures);
    document.addEventListener('shopify:section:load', findSignatures);
    const observed = new WeakSet();
    let observer;
    const animations = new Set();
    const pendingReveals = new WeakMap();
    const reveal = (scope = document) => {
      if (preference.matches || document.body.dataset.themeMotion === 'false' || window.Shopify?.designMode || !('IntersectionObserver' in window)) return;
      observer ??= new IntersectionObserver((entries) => {
        for (const [index, entry] of entries.entries()) {
          if (!entry.isIntersecting) continue;
          observer.unobserve(entry.target);
          const animation = pendingReveals.get(entry.target);
          pendingReveals.delete(entry.target);
          if (!animation) continue;
          if (entry.target.contains(document.activeElement) || preference.matches) {
            animation.cancel();
            continue;
          }
          animation.effect.updateTiming({ delay: Math.min(index * 70, 140) });
          animation.play();
        }
      }, { threshold: 0.08, rootMargin: '0px 0px -24px 0px' });
      const revealSelector = '.renaissance-copy__lead, .renaissance-copy__text > p, .renaissance-copy__text > h2, .renaissance-copy__text > h3, .renaissance-copy__text > ul, .renaissance-copy__actions, .editorial-signature, .contact-page__intro, .contact-page__details, .contact-page__form-panel, .renaissance-content__topic, .renaissance-content__intro, .editorial__item, .editorial__visual, .prose, .page-photo, .journal-page__articles > article, .estate-guide__items > *, .shopify-policy__body > *';
      for (const element of scope.querySelectorAll(revealSelector)) {
        if (element.parentElement?.closest(revealSelector)) continue;
        if (observed.has(element) || element.getBoundingClientRect().top < innerHeight) continue;
        observed.add(element);
        const initialTransform = element.querySelector('form') || element.matches('.editorial-signature') ? 'none' : 'translateY(8px)';
        const animation = element.animate([{ opacity: 0, transform: initialTransform }, { opacity: 1, transform: 'none' }], { duration: 850, fill: 'both', easing: 'cubic-bezier(0.22, 1, 0.36, 1)' });
        animation.pause();
        animation.currentTime = 0;
        animations.add(animation);
        pendingReveals.set(element, animation);
        const cleanup = () => {
          animations.delete(animation);
          pendingReveals.delete(element);
        };
        animation.finished.then(() => {
          cleanup();
          animation.cancel();
        }, cleanup);
        observer.observe(element);
      }
    };
    preference.addEventListener('change', () => {
      observer?.disconnect();
      animations.forEach((animation) => animation.cancel());
      animations.clear();
    });
    document.addEventListener('focusin', (event) => animations.forEach((animation) => {
      if (animation.effect.target.contains(event.target)) animation.cancel();
    }));
    document.addEventListener('shopify:section:load', (event) => reveal(event.target));
    document.addEventListener('shopify:section:unload', (event) => animations.forEach((animation) => {
      if (event.target.contains(animation.effect.target)) animation.cancel();
    }));
    reveal();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["localization-return"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches('.language-switcher--inline, .language-switcher__options, .localization-form')) return;
    const destination = form.elements.namedItem('return_to');
    if (destination instanceof HTMLInputElement) {
      const formRoot = new URL(form.action, location.origin).pathname.replace(/\/localization\/?$/, '').replace(/\/$/, '');
      let path = location.pathname;
      if (formRoot && (path === formRoot || path.startsWith(formRoot + '/'))) {
        path = path.slice(formRoot.length) || '/';
      }
      destination.value = path + location.search + location.hash;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["purchase-conditions"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeNativeVolumePrices = (scope = document) => {
      scope.querySelectorAll('[data-native-volume-prices]').forEach((pricing) => {
        if (pricing.dataset.volumeReady) return;
        const form = document.getElementById(pricing.dataset.formId);
        const quantity = form?.querySelector('input[name="quantity"]');
        const rows = [...pricing.querySelectorAll('[data-native-volume-tier]')];
        if (!quantity || !rows.length) return;
        const cartQuantity = Number(pricing.dataset.volumeCartQuantity) || 0;
        const minimum = Number(quantity.min) || 1;
        const increment = Number(quantity.step) || 1;
        const maximum = quantity.hasAttribute('max') ? Number(quantity.max) : Infinity;
        const summary = pricing.querySelector('[data-volume-summary]');
        const error = pricing.querySelector('[data-volume-error]');
        const announcement = pricing.querySelector('[data-volume-announcement]');
        const priceDisplays = [...document.querySelectorAll('[data-volume-price-form]')]
          .filter((display) => display.dataset.volumePriceForm === pricing.dataset.formId);
        let currencyFormat;
        try {
          currencyFormat = new Intl.NumberFormat(document.documentElement.lang || 'fr', {
            style: 'currency', currency: pricing.dataset.currency,
          });
        } catch {
          return;
        }
        const formatPrice = (price) => currencyFormat.format(price / 100);
        const update = (announce = false, preserveView = false) => {
          const commerce = window.ChateauCommerce;
          const view = preserveView ? commerce?.captureView(form) : null;
          try {
            const selectedQuantity = quantity.valueAsNumber;
            const valid = !quantity.disabled && Number.isInteger(selectedQuantity) && quantity.validity.valid;
            error.hidden = valid || quantity.disabled;
            summary.hidden = !valid;
            quantity.setAttribute('aria-invalid', String(!valid && !quantity.disabled));
            if (!valid) {
              rows.forEach((row) => {
                row.classList.remove('is-selected');
                row.querySelector('button').setAttribute('aria-pressed', 'false');
              });
              if (announce) announcement.textContent = quantity.disabled ? '' : error.textContent;
              return;
            }
            const combinedQuantity = cartQuantity + selectedQuantity;
            let selectedRow = rows[0];
            rows.forEach((row) => {
              if (combinedQuantity >= Number(row.dataset.threshold)) selectedRow = row;
            });
            const unitPrice = Number(selectedRow.dataset.price);
            const unitLabel = selectedRow.querySelector('[data-tier-price-label]').textContent.trim();
            const totalLabel = formatPrice(unitPrice * selectedQuantity);
            rows.forEach((row) => {
              const selected = row === selectedRow;
              row.classList.toggle('is-selected', selected);
              row.querySelector('button').setAttribute('aria-pressed', String(selected));
            });
            pricing.querySelector('[data-volume-unit-price]').textContent = unitLabel;
            pricing.querySelector('[data-volume-total-price]').textContent = totalLabel;
            pricing.querySelector('[data-volume-added-quantity]').textContent = `(${selectedQuantity})`;
            pricing.querySelector('[data-volume-combined-quantity]').textContent = pricing
              .querySelector('[data-volume-cart-template]').textContent.replace('[quantity]', combinedQuantity);
            priceDisplays.forEach((display) => { display.textContent = unitLabel; });
            if (announce) {
              announcement.textContent = pricing.querySelector('[data-volume-announcement-template]').textContent
                .replace('[quantity]', selectedQuantity).replace('[unit_price]', unitLabel).replace('[total]', totalLabel);
            }
          } finally {
            if (view) commerce.restoreView(view, form);
          }
        };
        rows.forEach((row) => {
          const button = row.querySelector('button');
          const remaining = Number(row.dataset.threshold) - cartQuantity;
          const amount = Math.max(minimum, minimum + Math.ceil((remaining - minimum) / increment) * increment);
          button.hidden = false;
          button.disabled = quantity.disabled || amount > maximum;
          button.addEventListener('click', () => {
            quantity.value = String(amount);
            quantity.dispatchEvent(new Event('input', { bubbles: true }));
            quantity.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
        pricing.dataset.volumeReady = 'true';
        quantity.addEventListener('input', () => update(false, true));
        quantity.addEventListener('change', () => update(true, true));
        update();
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeNativeVolumePrices(), { once: true });
    } else {
      initializeNativeVolumePrices();
    }
    document.addEventListener('shopify:section:load', (event) => initializeNativeVolumePrices(event.target));
    document.addEventListener('chateau:commerce:updated', (event) => initializeNativeVolumePrices(event.detail?.root || document));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["stay-search"] && !Shopify.designMode) return;
  try {
    (() => {
    const dayString = (date) =>
      `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    const parseDay = (value) => {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
      const date = new Date(`${value}T12:00:00`);
      return Number.isFinite(date.getTime()) && dayString(date) === value ? date : null;
    };
    const initialize = (root) => {
      root.querySelectorAll('[data-stay-search]').forEach((form) => {
        if (form.dataset.initialized) return;
        form.dataset.initialized = 'true';
        const arrival = form.elements.arrival;
        const departure = form.elements.departure;
        const guests = form.elements.guests;
        const error = form.querySelector('[role="alert"]');
        const today = () => dayString(new Date());
        const datesMinimum = () => {
          const minimum = today();
          if (arrival.min !== minimum) arrival.min = minimum;
          const day = parseDay(arrival.value);
          if (day) day.setDate(day.getDate() + 1);
          const departureMinimum = day ? dayString(day) : minimum;
          if (departure.min !== departureMinimum) departure.min = departureMinimum;
        };
        form.querySelectorAll('[data-date-picker]').forEach((button) => {
          const field = form.elements[button.dataset.datePicker];
          if (typeof field.showPicker !== 'function' || window.self !== window.top) return;
          const wrapper = button.closest('.stay-search__date');
          wrapper.classList.add('stay-search__date--enhanced');
          button.hidden = false;
          button.addEventListener('click', () => {
            datesMinimum();
            field.focus();
            try {
              field.showPicker();
            } catch {
              wrapper.classList.remove('stay-search__date--enhanced');
              button.hidden = true;
            }
          });
        });
        const validate = (report = false) => {
          datesMinimum();
          let invalid = null;
          let message = '';
          [arrival, departure, guests].forEach((field) => {
            field.setCustomValidity('');
            field.removeAttribute('aria-invalid');
          });
          if (!arrival.value || !departure.value || !guests.value) {
            invalid = [arrival, departure, guests].find((field) => !field.value);
            message = form.dataset.errorRequired;
          } else if (!parseDay(arrival.value) || arrival.value < today()) {
            invalid = arrival;
            message = form.dataset.errorArrival;
          } else if (!parseDay(departure.value) || departure.value <= arrival.value) {
            invalid = departure;
            message = form.dataset.errorDeparture;
          } else if (!Number.isSafeInteger(Number(guests.value)) || Number(guests.value) < 1) {
            invalid = guests;
            message = form.dataset.errorGuests;
          }
          if (invalid) {
            invalid.setCustomValidity(message);
            if (report) invalid.setAttribute('aria-invalid', 'true');
          }
          error.textContent = report ? message : '';
          error.hidden = !error.textContent;
          return !invalid;
        };
        form.addEventListener('input', () => validate(!error.hidden));
        form.addEventListener('change', () => validate(!error.hidden));
        form.addEventListener('invalid', () => validate(true), true);
        form.addEventListener('submit', (event) => {
          if (validate(true)) return;
          event.preventDefault();
          form.querySelector('[aria-invalid="true"]')?.focus();
        });
        if (form.closest('[data-stay-results]')) {
          const params = new URLSearchParams(window.location.search);
          const hasCriteria = ['arrival', 'departure', 'guests'].some((key) => params.has(key));
          if (hasCriteria) {
            arrival.value = params.get('arrival') || '';
            departure.value = params.get('departure') || '';
            guests.value = params.get('guests') || '';
            const result = form.closest('[data-stay-results]');
            if (validate(true)) {
              const criteria = { arrival: arrival.value, departure: departure.value, guests: Number(guests.value) };
              result.dataset.stayArrival = criteria.arrival;
              result.dataset.stayDeparture = criteria.departure;
              result.dataset.stayGuests = String(criteria.guests);
              result.dataset.stayState = 'awaiting-provider';
              result.dispatchEvent(new CustomEvent('piegue:stay-search', { bubbles: true, detail: criteria }));
            } else {
              result.dataset.stayState = 'invalid';
            }
          }
        }
        datesMinimum();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
    else initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
